


















import { Component, Prop, Vue } from 'vue-property-decorator';
import PartVideo from '@/components/Video/Video.vue';
import SwiperScroll from '@/components/SwiperScroll/SwiperScroll.vue';

@Component({
  components: {
    PartVideo,
    SwiperScroll,
  },
})
export default class PartOne extends Vue {
  private videoData: any = {
    poster: {
      src: require('@/assets/video/part5.png'),
      height: '8.61rem',
    },
    video: [
      {
        src: require('@/assets/video/part5.mp4'),
        type: 'video/mp4',
      },
    ],
  };
}
